import {
  Component,
  HostListener,
  Input,
  OnInit,
  ElementRef,
  ViewChild,
  signal,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { loadData, loadlead, setData } from 'src/storage/general.actions';
import { QueryParamService } from '@app/services/general/query-param.service';
import {
  correoConDosExtensiones,
  ValidatorsService,
} from '@app/utils/validadors';
import { OrquestadorService } from '@app/services/orquestador/orquestador.service';
import { GeneralDataService } from '@app/services/general/general-data.service';
import { DataLayerService } from '@app/services/dataLeyer/data-leyer.service';
import { OrquestadorInquilinoService } from '@app/tenant/services/OrquestadorInquilino/orquestador-inquilino.service';
import { LoaderService } from '@app/services/general/loader.service';
import { Store } from '@ngrx/store';
import { selectDataByKey } from 'src/storage/general.selectors';
import { Observable, Subscription } from 'rxjs';
import { Console } from 'console';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cotizador',
  templateUrl: './cotizador.component.html',
  styleUrls: ['./cotizador.component.scss'],
})
export class CotizadorComponent implements OnInit {
  // TO DO VALIDAR
  @Input() codasesor: string = '';
  @ViewChild('inquilinoForm') inquilinoForm!: ElementRef;
  @ViewChild('hasInquilino') hasInquilino!: ElementRef;
  sessionId: string = '';
  enablePromo: boolean = environment.bannerEnabled;
  private startDate: Date = new Date(environment.bannerStartDate);
  private endDate: Date = new Date(environment.bannerEndDate);

  body: any;
  happyres$: Observable<any>;
  bitacoraId: string = '';
  tenant$: Observable<any>;
  leadId$: Observable<any>;
  bitacoraId$: Observable<any>;
  private subscriptions: Subscription = new Subscription();
  res: any;

  // Legacy properties (keeping for backward compatibility)

  renta: any = null;
  admin: any = null;
  tipo: string = '';
  duration: number = 6;
  arrendamiento: string = '';
  administracion: string = '';
  asesorCode: string = '';

  uso: string = '';
  duracion: number = 0;
  name: string = '';
  email: string = '';
  formData = {
    tipoId: 'Cédula de ciudadanía',
    numId: '',
    autorizacion: false,
  };
  isModalVisible: boolean = false;
  modalMessage: any;
  numId: string = '';
  isLoading: any;
  loaded: boolean = false;
  isMobile: boolean = false;
  isFormComplete: boolean = false;
  inquilino: string = '';
  isClicked: boolean = false;
  maxValueAdmin: boolean = false;

  // Reactive Forms
  inmuebleForm: FormGroup;
  contactForm: FormGroup;
  tenantForm: FormGroup;
  isValidAdvisor = signal(true);

  private backupValueDocument: string | null = null;

  constructor(
    private queryParamService: QueryParamService,
    private orquestadorService: OrquestadorService,
    private generalDataService: GeneralDataService,
    private _dataLayerService: DataLayerService,
    private fb: FormBuilder,
    private validatorsService: ValidatorsService,
    private route: ActivatedRoute,
    private router: Router,

    private loaderService: LoaderService,
    private store: Store
  ) {
    this.happyres$ = this.store.select(selectDataByKey('leadId'));
    this.tenant$ = this.store.select(selectDataByKey('tenant'));
    this.leadId$ = this.store.select(selectDataByKey('leadId'));
    this.bitacoraId$ = this.store.select(selectDataByKey('bitacoraId'));
    this.isMobile = window.innerWidth <= 1024;

    // Initialize Inmueble Form
    this.inmuebleForm = this.fb.group({
      valorArrendamiento: ['', [Validators.required, Validators.min(500000)]],
      valorAdministracion: [
        '',
        [
          Validators.required,
          Validators.min(0),
          this.validateValorAdmon.bind(this),
        ],
      ],
      tipoPropiedad: ['Residencial', Validators.required],
      TemporaryContracted: [12, Validators.required],
      tieneInquilino: ['', Validators.required],
    });

    // Initialize Contact Form (for when no tenant)
    this.contactForm = this.fb.group({
      LastName: [
        '',
        [Validators.required, Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/)],
      ],
      Mail: [
        '',
        [Validators.required, Validators.email, correoConDosExtensiones],
      ],
    });

    // Initialize Tenant Form (for when tenant exists)
    this.tenantForm = this.fb.group({
      DocumentType: ['C', Validators.required],
      DocumentNumber: [
        '',
        [
          Validators.required,
          Validators.minLength(7),
          Validators.maxLength(10),
        ],
      ],
      PersonalDataAuthorization: [false, Validators.requiredTrue],
    });
  }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'));
  }

  private validateValorAdmon(control: any): { [key: string]: boolean } | null {
    const valorArrendamiento =
      this.inmuebleForm?.get('valorArrendamiento')?.value || 0;
    const maxValorAdmon = valorArrendamiento * 0.35;
    if (control.value > maxValorAdmon) {
      this.isFormComplete = false;
      this.inmuebleForm.invalid;
      this.inmuebleForm.get('valorAdministracion')?.invalid;
      this.maxValueAdmin = true;
      return { maxExceeded: true };
    }

    // this.inmuebleForm.valid;
    this.isFormComplete = true;
    this.maxValueAdmin = false;

    return null;
  }

  ngOnInit(): void {
    this.loaderService.show(); // Mostrar el loader al iniciar la carga de datos
    this.loaderService.loading$.subscribe(
      ({ loading, loaded }: { loading: boolean; loaded: boolean }) => {
        this.isLoading = loading;
        this.loaded = loaded;
      }
    );
    this.enablePromo = this.isWithinActivePeriod();

    this.sessionId = this.getLocalStorage().toString();

    this.inmuebleForm = this.fb.group({
      valorArrendamiento: ['', [Validators.required, Validators.min(500000)]],
      valorAdministracion: [
        '',
        [
          Validators.required,
          Validators.min(0),
          this.validateValorAdmon.bind(this),
        ],
      ],
      tipoPropiedad: ['Residencial', Validators.required],
      TemporaryContracted: [12, Validators.required],
      tieneInquilino: ['', Validators.required],
    });

    this.route.queryParams.subscribe((params) => {
      if (params['codigoAsesor']) {
        this.codasesor = params['codigoAsesor'];
        //console.log('Codigo Asesor from URL:', this.codasesor);
      }
    });

    this.generalDataService.getData(['Tenant']).subscribe((data) => {
      if (data.Tenant) {
        // Realiza el patchValue del formulario

        const formData: any = {
          DocumentType: data.Tenant.DocumentType || 'C',
          DocumentNumber: data.Tenant.DocumentNumber || '',
          PersonalDataAuthorization:
            data.Tenant.PersonalDataAuthorization || false,
        };

        this.tenantForm.patchValue(formData);

        // Recorre las propiedades del objeto y marca como tocados
        for (const key in formData) {
          if (formData[key] !== undefined && formData[key] !== '') {
            this.tenantForm.get(key)?.markAsTouched();
            //this.tenantForm.add(key);
          }
        }
      }
    });

    this.generalDataService.getData(['Property']).subscribe((data) => {
      if (data.Property) {
        // Realiza el patchValue del formulario

        const formData: any = {
          valorArrendamiento: data.Property.RentalFee,
          valorAdministracion: data.Property.AdministrationValue,
          tipoPropiedad: data.Property.UseProperty,
        };

        this.inmuebleForm.patchValue(formData);

        // Recorre las propiedades del objeto y marca como tocados
        for (const key in formData) {
          if (formData[key] !== undefined && formData[key] !== '') {
            this.inmuebleForm.get(key)?.markAsTouched();
            //this.tenantForm.add(key);
          }
        }
      } else {
        const body = {
          getInitialData: true,
        };
        this.loaderService.show();

        this.store.dispatch(loadData({ body }));
      }
    });

    this.generalDataService.getData(['PolicyHolder']).subscribe((data) => {
      if (data.PolicyHolder) {
        // Realiza el patchValue del formulario

        const formData: any = {
          LastName: data.PolicyHolder.LastName || '',
          Mail: data.PolicyHolder.Mail || '',
        };

        this.contactForm.patchValue(formData);

        // Recorre las propiedades del objeto y marca como tocados
        for (const key in formData) {
          if (formData[key] !== undefined && formData[key] !== '') {
            this.contactForm.get(key)?.markAsTouched();
            //this.tenantForm.add(key);
          }
        }
      }
    });

    // console.log('Codigo Asesor: ', this.codasesor);

    this.loaderService.hide();

    this._dataLayerService.logDataNewFlow(
      'Arriendo_ecommerce_step_0_Inicio',
      'Arriendo',
      'Inicio Arriendo',
      'Pageview',
      this.sessionId
    )
  }

  get imagenInquilino(): string {
    const tieneInquilino = this.inmuebleForm.get('tieneInquilino')?.value;
    return tieneInquilino === 'Sí'
      ? './assets/img/check32.png'
      : './assets/img/Familia.png';
  }

  // Form validation helper
  isValidField(formGroup: FormGroup, field: string): boolean {
    const control = formGroup.get(field);
    return !!(control && control.errors && control.touched);
  }

  public validateNumber(event: KeyboardEvent): void {
    const pattern = /^[0-9]$/;
    const inputChar = event.key;

    // Permitir teclas de control (Backspace, Tab, Flechas, Delete)
    if (
      ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(
        inputChar
      )
    ) {
      return;
    }

    // Bloquear caracteres especiales como tildes y diéresis
    if (
      !pattern.test(inputChar) ||
      ['´', '¨', '`', '^', '~'].includes(inputChar)
    ) {
      console.log('entro xx');
      event.preventDefault();
    }
  }

  getFieldError(formGroup: FormGroup, field: string): string {
    const control = formGroup.get(field);
    if (control && control.errors && control.touched) {
      if (control.errors['required']) return 'Asegúrate de llenar este campo';
      if (control.errors['email']) return "Asegúrate de ingresar un correo válido";
      if (field === 'numeroIdentificacion' && control.errors['pattern'])
        return 'Asegúrate de incluir solo números y que tengan entre 7 y 10 dígitos';
      if (control.errors['numeroIdentificacion'])
        return 'Asegúrate de incluir solo números y que tengan entre 7 y 10 dígitos';
      if (control.errors['min'])
        return 'El valor del arriendo no puede ser menor a $500.000';
      if (control.errors['pattern']) return 'Formato inválido';
      if (control.errors['minlength']) return 'Mínimo 2 caracteres';
      if (field === 'valorAdministracion' && control.errors['maxExceeded'])
        return 'El valor de la administración no puede superar el 35% del valor ingresado en el campo arriendo';
    }
    return '';
  }

  getLabelClasses(
    formGroup: FormGroup,
    field: string
  ): { [key: string]: boolean } {
    const control = formGroup.get(field);
    if (!control) return {};

    return {
      'label-invalid': control.invalid && control.touched,
      'label-valid': control.valid && control.touched && control.value,
      'label-default': !control.touched,
    };
  }

  onUsoChange() {
    const tipoPropiedad = this.inmuebleForm.get('tipoPropiedad')?.value;
    const valorArrendamiento =
      this.inmuebleForm.get('valorArrendamiento')?.value;
    const valorAdministracion = this.inmuebleForm.get(
      'valorAdministracion'
    )?.value;
    const tieneInquilino = this.inmuebleForm.get('tieneInquilino')?.value;

    // Update legacy properties for backward compatibility
    this.tipo = tipoPropiedad;
    this.renta = valorArrendamiento;
    this.admin = valorAdministracion;
    this.inquilino = tieneInquilino;

    if (
      tipoPropiedad === 'Residencial' &&
      valorArrendamiento != null &&
      valorArrendamiento !== '' &&
      valorAdministracion != null &&
      valorAdministracion !== '' &&
      this.isFormComplete === true
    ) {
      this.isFormComplete = true;
      this.inquilinoForm.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    } else {
      this.isFormComplete = false;
    }

    if (tipoPropiedad === 'Comercial') {
      this.store.dispatch(
        setData({
          key: 'leadRequirement',
          value: 'Uso comercial',
          merge: false,
        })
      );
      this.router.navigate(['/seguros/hogar/arriendo/cotizador/cotizacion-pausa']);
    }

    if (tieneInquilino === 'Sí') {
      setTimeout(() => {
        this.hasInquilino.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 100);
      this.contactForm.reset({
        LastName: '',
        Mail: '',
      });
    } else if (tieneInquilino === 'No') {
      setTimeout(() => {
        this.hasInquilino.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 100);
      this.tenantForm.reset({
        DocumentType: 'C',
        DocumentNumber: '',
        PersonalDataAuthorization: false,
      });
    }
  }

  continue() {
    this.isClicked = true;
    const queryParams = this.asesorCode
      ? { codigoAsesor: this.asesorCode }
      : {};

    if (this.tenantForm.valid) {
      const Property = {
        //Code: this.selectedObject?.SURACodigo__c || this.property.Code,
        //CityCode: this.selectedObject?.SuraCodigoCiudad__c || this.property.CityCode,
        AdministrationValue:
          this.inmuebleForm.value.valorAdministracion ||
          this.inmuebleForm.get('valorAdministracion')?.value,
        // Department: this.selectedObject?.SURADepartamento__c || this.property.Department,
        RentalFee: this.inmuebleForm.value.valorArrendamiento,

        //DepartmentCode: this.selectedObject?.SuraCodigoDepartamento__c || this.property.DepartmentCode,
        UseProperty: this.inmuebleForm.value.tipoPropiedad,
        //CityProperty: this.selectedObject?.SURACiudad__c || this.property.CityProperty,

        TemporaryContracted:
          this.inmuebleForm.value.TemporaryContracted.toString() || '6',

        // ❌ Valores removidos: No debe haber ciudad por defecto
        // CityProperty: 'Villavicencio',
        // Department: 'Meta',
      };

      this.store.dispatch(
        setData({
          key: 'Property',
          value: Property,
          merge: false,
        })
      );

      const tenant = {
        DocumentType: this.tenantForm.value.DocumentType,
        DocumentNumber: this.tenantForm.value.DocumentNumber,
        PersonalDataAuthorization: this.tenantForm.value.flexCheckAutoriza,
      };

      this.store.dispatch(
        setData({
          key: 'Tenant',
          value: tenant,
          merge: false,
        })
      );

      const totalValue =
        this.inmuebleForm.value.valorAdministracion +
        this.inmuebleForm.value.valorArrendamiento;
      if (
        totalValue > 5000000 ||
        this.inmuebleForm.value.tipoPropiedad === 'Comercial'
      ) {
        this.store.dispatch(
          setData({
            key: 'leadRequirement',
            value:
              'Valor maximo de cannon + administración  || uso del inmueble',
            merge: false,
          })
        );

        this.router.navigate(['seguros/hogar/arriendo/cotizador/cotizacion-pausa']);
      } else {
        const options: any = {
          keys: ['Tenant', 'Property'],
          screenPercentage: '5',
          leadId: 'leadId', // ✅ Agregar leadId para retoma
        };

        if (this.asesorCode !== '') {
          this.store.dispatch(
            setData({
              key: 'codigoAsesor',
              value: this.asesorCode,
              merge: false,
            })
          );

          options.asesorCode = this.asesorCode;
        }

        window.scrollTo(0, 0);
        this.loaderService.show();

        this.generalDataService.getbody(options).subscribe((body) => {
          console.log('Generated body (cotizador - primer submit):', body);
          console.log('📋 leadId en body:', body.leadId ? `✅ ${body.leadId}` : '⚠️ No disponible');

          this.body = body;
          this.store.dispatch(loadlead({ body: this.body }));

          //         this.store.dispatch(
          //           loadlead({ body: this.body })
          // );
        });

        this.subscriptions.add(
          this.happyres$.subscribe((resume) => {
            this.res = resume;
            if (this.res) {
              //this.router.navigate(['cotizador-inquilino'], { relativeTo: this.route.parent });

              console.log('Happy response:', resume);

              // New options configuration and generalDataService call
              const options: any = {
                keys: ['Tenant', 'Property'],
                leadId: 'leadId',
                getTenantPolicies: true,
                screenPercentage: '5',
              };

              if (this.codasesor !== '') {
                options.asesorCode = this.codasesor;
                options.bitacoraId = this.bitacoraId;
              }

              this.generalDataService.getbody(options).subscribe((body) => {
                console.log('Generated body:', body);

                this.body = body;
                this.store.dispatch(loadlead({ body: this.body }));

                //         this.store.dispatch(
                //           loadlead({ body: this.body })
                // );
              });
            }
          })
        );

        this.subscriptions.add(
          this.tenant$.subscribe((resume) => {
            // atrapa si tiene mas de dos polizas

            //this._dataLayerService.logEvent("ecommerce_step_1", "Arrendamiento", "Inicio Arrendamiento", this.sessionId);
            this.res = resume;
            if (this.res === true) {
              // To do rutea a pausa

              this.loaderService.hide();
              this.router.navigate(['seguros/hogar/arriendo/cotizador/cotizacion-pausa'], { queryParams });
            } else if (this.res === false) {
              console.log('No tiene mas de dos polizas');
              this.loaderService.hide();
              this.router.navigate(['seguros/hogar/arriendo/cotizador/loader'], { queryParams });
              //  rutea a la new loader
              //this.router.navigate(['datos-propiedad'], { relativeTo: this.route.parent });
            }
            //console.log('Lead happy', this.res);
          })
        );
      }
    }
    if (this.contactForm.valid) {
      const PolicyHolder = {
        LastName: this.contactForm.value.LastName.split(' ')[0], // Extract only the first segment
        Mail: this.contactForm.value.Mail,
      };

      this.store.dispatch(
        setData({
          key: 'PolicyHolder',
          value: PolicyHolder,
          merge: false,
        })
      );

      const Property = {
        //Code: this.selectedObject?.SURACodigo__c || this.property.Code,
        //CityCode: this.selectedObject?.SuraCodigoCiudad__c || this.property.CityCode,
        AdministrationValue:
          this.inmuebleForm.value.valorAdministracion ||
          this.inmuebleForm.get('valorAdministracion')?.value,
        RentalFee: this.inmuebleForm.value.valorArrendamiento,
        //DepartmentCode: this.selectedObject?.SuraCodigoDepartamento__c || this.property.DepartmentCode,
        UseProperty: this.inmuebleForm.value.tipoPropiedad,
        //CityProperty: this.selectedObject?.SURACiudad__c || this.property.CityProperty,

        TemporaryContracted:
          this.inmuebleForm.value.TemporaryContracted.toString() || '6',

        // ❌ Valores removidos: No debe haber ciudad por defecto
        // CityProperty: 'Villavicencio',
        // Department: 'Meta',
        // DepartmentCode: '17',
        // Code: '1717174',
        // CityCode: '17174',
      };

      this.store.dispatch(
        setData({
          key: 'Property',
          value: Property,
          merge: false,
        })
      );

      const options: any = {
        keys: ['PolicyHolder'],
        screenPercentage: '5',
        leadId: 'leadId', // ✅ Agregar leadId para retoma
      };

      this.generalDataService.getbody(options).subscribe((body) => {
        console.log('Generated body:', body);
        this.body = body;
        // Solo asignar 'provisional' si no hay leadId del Lead Resume
        if (!this.body.leadId) {
          this.body.leadId = 'provicional';
        }
        this.body.leadRequirement = 'Sin inquilino';
        this.body.leadStatus = '0_Descartado';
        console.log('Generated body:', this.body);

        this.store.dispatch(loadlead({ body: this.body }));

        this.subscriptions.add(
          this.leadId$.subscribe((leadId) => {
            if (leadId) {
              this.loaderService.hide();
              this.router.navigate(['seguros/hogar/arriendo/cotizador/tenemos-tus-datos'], { queryParams });
            } else {
            }
          })
        );
      });
    } else {
      console.log('Formulario de contacto inválido');
      this.contactForm.markAllAsTouched();
    }
  }

  guardarUrlPersonalizada() {
    const baseUrl = window.location.origin + window.location.pathname;
    const url = new URL(baseUrl);
    const formValues = this.inmuebleForm.value;

    url.searchParams.set(
      'renta',
      formValues.valorArrendamiento?.toString() || ''
    );
    url.searchParams.set(
      'admin',
      formValues.valorAdministracion?.toString() || ''
    );
    url.searchParams.set('tipo', formValues.tipoPropiedad || '');
    url.searchParams.set(
      'duracion',
      formValues.TemporaryContracted?.toString() || ''
    );

    const urlPersonalizada = url.toString();
    console.log('URL personalizada:', urlPersonalizada);
    localStorage.setItem('cotizacionUrl', urlPersonalizada);
  }

  validateNumId(numId: string): boolean {
    return /^\d{7,10}$/.test(numId);
  }

  submitForm(): void {
    if (this.tenantForm.valid) {
      const numeroId = this.tenantForm.get('numeroIdentificacion')?.value;
      if (!this.validateNumId(numeroId)) {
        this.isModalVisible = true;
      } 
    } else {
      console.log('Formulario de inquilino inválido');
      this.tenantForm.markAllAsTouched();
    }
  }

  showLoader(): void {
    this.isLoading = true;
    console.log('Cargando...');
  }

  closeModal(): void {
    this.isModalVisible = true;
  }

  editId(): void {
    this.isModalVisible = false;
  }

  getSliderBackground() {
    const duration = this.inmuebleForm.get('TemporaryContracted')?.value || 6;
    // Update legacy property for backward compatibility
    this.duration = duration;
    //let percentage = (duration - 6) / (12 - 6);
    if (duration === 6) {
      return 'linear-gradient(to right, #2d6df6 50%, #F8F8F8 50%)';
    } else {
      return 'linear-gradient(to right, #2d6df6 100%, #F8F8F8 100%)';
    }

    //return `linear-gradient(to right, #2d6df6 ${percentage}%, #F8F8F8 ${percentage}%)`;
  }
  isModalOpen = false;

  openModal() {
    const documentNum = this.tenantForm.get('DocumentNumber')?.value;
    this.tenantForm.get('DocumentNumber')?.setValue(documentNum);
    this.backupValueDocument = documentNum;
    this.isModalOpen = true;

    this._dataLayerService.logCotizacion(
      'Arriendo_ecommerce_step_0_Cotizar',
      'Arriendo',
      'Validacion canon + admin',
      'Button',
      this.sessionId,
      this.renta,
      this.admin,
      this.tipo,
      false
    )
  }

  closeModalButton(cancelled: boolean = true) {
    if (cancelled && this.backupValueDocument !== null) {
      this.tenantForm.get('DocumentNumber')?.setValue(this.backupValueDocument);
      this.tenantForm.get('DocumentNumber')?.markAsPristine();
      this.tenantForm.get('DocumentNumber')?.updateValueAndValidity();
    }
    this.isModalOpen = false;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobile = window.innerWidth <= 1024;
  }

  validateAlpha(event: KeyboardEvent) {
    const regex = /^[A-Za-z\s]+$/;
    const inputChar = event.key;
    if (
      !regex.test(event.key) ||
      ['´', '¨', '`', '^', '~'].includes(inputChar)
    ) {
      console.log('entro ff');
      event.preventDefault();
    }
  }

  handleAdvisorBehavior(isValid: boolean) {
    if (isValid) {
      this.isValidAdvisor.set(false);
    }

    if (!isValid) {
      this.isValidAdvisor.set(true);
    }
  }

  handleAdvisorSelected(advisor: any) {
    if (advisor && advisor.Cod) {
      this.store.dispatch(
        setData({
          key: 'codigoAsesor',
          value: advisor.Cod,
          merge: false,
        })
      );

      this.asesorCode = advisor.Cod;
      this.codasesor = advisor.Cod;
    }
  }

  validateValueAdmin() {
    const valorArrendamiento =
      this.inmuebleForm.get('valorArrendamiento')?.value;
    const valorAdministracion = this.inmuebleForm.get(
      'valorAdministracion'
    )?.value;

    if ((valorArrendamiento || 0) + (valorAdministracion || 0) > 5000000 || this.maxValueAdmin) {
      this._dataLayerService.logCotizacion(
        'Arriendo_ecommerce_step_0.5_Validacion',
        'Arriendo',
        'Validacion canon + admin',
        'Pageview',
        this.sessionId,
        valorArrendamiento,
        valorAdministracion,
        this.tipo,
        true
      )
    }
  }

  private isWithinActivePeriod(): boolean {
    const now = new Date();
    return now >= this.startDate && now <= this.endDate;
  }
}
